<!--template>
we use inline template here
</template-->

<script>
export default {
  name: 'HomeTagBasedEntry',
  data() {
    return {
      collapsed: true,
      collapseScrollTimeout: null,
      pendingCollapseScroll: false,
    };
  },
  mounted() {
    if (window.jQuery) {
      window.jQuery(this.$el).on('hidden.bs.collapse', '.multi-collapse', this.handleCollapseHidden);
    }
  },
  beforeDestroy() {
    if (window.jQuery) {
      window.jQuery(this.$el).off('hidden.bs.collapse', '.multi-collapse', this.handleCollapseHidden);
    }

    this.clearCollapseScrollTimeout();
  },
  methods: {
    toggleCollapsed(event) {
      const wasExpanded = !this.collapsed;

      this.collapsed = !this.collapsed;

      if (wasExpanded) {
        this.scheduleScrollAfterCollapse(event && event.currentTarget);
      }
    },
    scheduleScrollAfterCollapse(clickedButton) {
      this.pendingCollapseScroll = true;
      this.collapseScrollButton = clickedButton;
      this.clearCollapseScrollTimeout();

      this.collapseScrollTimeout = window.setTimeout(() => {
        this.scrollToToggleButton(this.collapseScrollButton);
      }, 500);
    },
    handleCollapseHidden() {
      if (!this.pendingCollapseScroll) {
        return;
      }

      this.scrollToToggleButton(this.collapseScrollButton);
    },
    clearCollapseScrollTimeout() {
      if (this.collapseScrollTimeout) {
        window.clearTimeout(this.collapseScrollTimeout);
        this.collapseScrollTimeout = null;
      }
    },
    scrollToToggleButton(button) {
      this.pendingCollapseScroll = false;
      this.clearCollapseScrollTimeout();

      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          button = button || this.$refs.toggleButton;

          if (!button) {
            return;
          }

          if (typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped>

</style>
